import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LandingpageSuccessGuard {
  private successAllowed = false;

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (this.successAllowed) {
      return true;
    }
    return this.router.parseUrl('/403');
  }

  allowSuccessPage(allow: boolean) {
    this.successAllowed = allow;
  }
}
